var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2 offset-md-4 text-right center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-fill",
              attrs: { type: "submit" },
              on: { click: _vm.editPress }
            },
            [_vm._v("Edit Press Release")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.press
        ? _c("div", { staticClass: "table-responsive" }, [
            _c("table", { staticClass: "table table-bordered table-light" }, [
              _c("tr", [
                _c("th", [_vm._v("Id")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.press.pressRoomContentId))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Type")]),
                _vm._v(" "),
                _c("td", [
                  _vm.press.contentOrder === 2
                    ? _c("span", [_vm._v("Press Release")])
                    : _c("span", [_vm._v("In the News")])
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Date")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.press.topicSubHeadDateFmt))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Heading")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.press.topicSubHead))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Description")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.press.topicSubHeadContents))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Attached Link")]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.press.pdfUrl,
                        title: _vm.press.topicSubHead,
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.press.pdfUrl))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Status")]),
                _vm._v(" "),
                _vm.press.active == "0"
                  ? _c("td", [_vm._v("Inactive")])
                  : _c("td", [_vm._v("Active")])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Press Release Details")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bc9c392", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bc9c392","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Press/PressDetails.vue
// module id = D9lw
// module chunks = 0